import { ref, onMounted, onBeforeUnmount } from 'vue'

/**
 * Detects whether the device is *only touch operated*
 * (i.e. no fine pointer like a mouse or trackpad).
 *
 * Returns a reactive boolean `isTouchOnly`.
 */
export function useIsTouchOnly() {
  const isTouchOnly = ref(false)

  let coarseQuery: MediaQueryList
  let fineQuery: MediaQueryList

  const update = () => {
    const coarse = coarseQuery.matches
    const fine = fineQuery.matches
    isTouchOnly.value = coarse && !fine
  }

  onMounted(() => {
    coarseQuery = window.matchMedia('(any-pointer: coarse)')
    fineQuery = window.matchMedia('(any-pointer: fine)')

    // Initial detection
    update()

    // React to changes (e.g. plugging in a mouse)
    coarseQuery.addEventListener('change', update)
    fineQuery.addEventListener('change', update)
  })

  onBeforeUnmount(() => {
    coarseQuery?.removeEventListener('change', update)
    fineQuery?.removeEventListener('change', update)
  })

  return { isTouchOnly }
}
